<template>
  <div class="project-selector">
    <input :value="selectProjects.length" type="hidden" name="projects" />
    <div v-if="projects" class="project-box row m-0 p-0">
      <div class="col-7 p-0 list-height">
        <div class="head row p-0 m-0">
          <div class="project-search input-group col-8 p-2">
            <span id="basic-addon1" class="input-group-text">
              <i class="fas fa-search"></i>
            </span>
            <input
              v-model="searchProject"
              :placeholder="$t('feature.article.setting.project_search')"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="projects col">
          <div
            v-for="project in projects"
            :key="project.project_id"
            class="media tag"
            @click="handleSelectProject(project)"
          >
            {{ project.projectFullname }}
          </div>
        </div>
      </div>
      <div v-if="selectProjects" class="results-panel col-5 p-0 list-height">
        <div class="media projects-head">
          <div class="projects-counter media-body">
            เลือกแล้ว {{ selectProjects.length }} โครงการ
          </div>
          <div class="projects-remove mt-1 pointer" @click="removeProjectAll()">
            ลบทั้งหมด
          </div>
        </div>
        <div class="project-select col px-0">
          <div
            v-for="(selectProject, index) in selectProjects"
            :key="selectProject.project_id"
            class="media tag"
          >
            <div class="media-body">
              {{ selectProject.projectFullname }}
            </div>
            <div class="ms-3" @click="removeProject(index)">
              <img src="/static/icons/close.svg" alt="remove" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    projectIdsByFilter: {
      type: Array,
      default: null
    },
    projectType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      allProjects: [],
      searchProject: "",
      selectProjects: [],
    }
  },
  computed: {
    projects() {
      // เช็ค project ตามกล่องค้นหา (searchProject)
      const projectsFilterByTextSearch = this.allProjects.filter((project) =>
        project.projectFullname
          .toLowerCase()
          .includes(this.searchProject.toLowerCase()),
      )

      // เช็ค diff ของโครงการที่เลือกแล้ว
      if (this.selectProjects.length > 0) {
        return projectsFilterByTextSearch.filter(
          ({ project_id: id1 }) =>
            !this.selectProjects.some(({ project_id: id2 }) => id2 === id1),
        )
      }

      return projectsFilterByTextSearch
    },
  },
  watch: {
    value: function watchValue() {
      this.mapInputProjects()
    },
    projectType: function watchProjectType(newValue) {
      if (newValue) {
        const projectIdsByType = this.allProjects
          .filter((project) => project.project_type === newValue)
          .map((i) => i.project_id)

        this.$emit("projectIdsByType", [...new Set(projectIdsByType)])
      } else {
        this.$emit("projectIdsByType", [])
      }
    },
    projectIdsByFilter: function watchProjectIdsByFilter(newValue) {
      if (newValue) {
        const projects = this.allProjects.filter((project) =>
          newValue.includes(project.project_id),
        )

        this.selectProjects = projects
        this.$emit("input", this.selectProjects)
      } else {
        this.$emit("input", [])
      }
    },
  },
  created() {
    this.fetchProjects()
  },
  methods: {
    async fetchProjects() {
      const data = { searchText: this.searchProject }
      const projects = await this.getProjects(data)
      // Exclude test projects
      const excludeProjectIds = ["3", "41", "52", "180", "666"]

      this.allProjects = projects
        .filter((project) => !excludeProjectIds.includes(project.project_id))
        .map((project) => ({
          ...project,
          projectFullname: `${project.project_code} - ${project.project_name}`,
        }))
    },
    async getProjects(data) {
      const response = await baanRueJaiClient.admin.projects.search(data)

      return response.data.result.data
    },
    handleSelectProject(project) {
      if (!this.checkProjectDupicate(project)) {
        this.selectProjects = this.selectProjects.concat(project)
        this.$emit("input", this.selectProjects)
      }
    },
    removeProject(index) {
      this.selectProjects.splice(index, 1)
      this.$emit("input", this.selectProjects)
    },
    checkProjectDupicate(project) {
      return this.selectProjects.some(pro => pro.project_id === project.project_id)
    },
    mapInputProjects() {
      if (!this.value) return
      this.selectProjects = this.allProjects.filter((project) =>
        this.value.some((p) => p.project_id === project.project_id),
      )
    },
    removeProjectAll() {
      this.selectProjects = []
      this.$emit("input", this.selectProjects)
    },
  },
}
</script>

<style lang="scss" scoped>
.list-height {
  height: calc(100vh - 400px);
}

.project-box {
  border-radius: 15px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  max-height: calc(100vh - 400px);

  &.error {
    border-color: $red;
  }
  .head {
    border-bottom: 1px solid #e0e0e0;
    max-height: 49px;
  }
  .results-panel {
    border-left: 1px solid #e0e0e0;

    &.no-left-border {
      border-left: none;
    }
  }
  .filter {
    padding: 6px 10px 0 0;
    text-align: right;
    border-left: 1px solid #e5e5e5;
  }
  input.form-control {
    border: none;
  }
  .dropdown {
    button {
      border: none;
    }
  }
}
.projects {
  background-color: #ffffff;
  height: calc(100% - 48px);
  padding: 10px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;

  &-counter {
    font-weight: bold;
    color: $orange;
  }
  &-head {
    padding: 10px;
    line-height: 1.98;
    border-bottom: 1px solid #e0e0e0;
  }
  &-remove {
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.64;
    letter-spacing: -0.1px;
    text-align: right;
    color: #8c8786;
  }
  .all {
    font-weight: bold;
    color: $black;
    margin-bottom: 6px;
  }
}
.project {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
  padding-left: 16px;
  border-left: 1px solid #979797;

  &-group {
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: $black;
    margin: 8px 0;
  }
  &-select {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
  &:hover {
    color: $black;
  }
}
.dropdown {
  display: inline;
}
.input-group-text {
  background: none;
  border: none;
  border-radius: 25px;
  background-color: $white;
}
.tag {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: $black;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px;
}

.project-selector {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: $black;
  padding: 16px;
}
</style>
